import { createGlobalStyle } from 'styled-components'
import { calculateResponsiveSize } from '@dboxdev/ui-components'

// Theme map in the shape LayoutProvider expects: name → { colors, fonts }. The
// active theme's settings are spread onto styled-components' theme, so components
// read `theme.colors.*` (and `themeColor(...)`) from context, and
// ThemeGlobalStyles emits the `--font-*` custom properties. Real font files are
// loaded via @font-face in fonts.css.
export const themes = {
  Default: {
    colors: {
      textColor: 'rgba(0, 0, 0, 0.6)',
      backgroundColor: '#ffffff',
      accentColor: '#A39383'
    },
    fonts: {
      primary: "'Gerstner', Arial, Tahoma, Geneva, sans-serif",
      secondary: "'Latinotype juana', Georgia, 'Times New Roman', serif"
    }
  }
}

export const defaultTheme = 'Default'

// Layer 3 — project-only rules, layered on top of the packaged BaseGlobalStyles
// (reset) + ThemeGlobalStyles (brand) that LayoutProvider injects. Colors, the
// box-model reset, font-family, .for-mobile/.for-desktop and the Safari autofill
// fix all come from those two layers — don't repeat them here.
export const GlobalStyle = createGlobalStyle`
  html, body {
    width: 100%;
    height: 100%;
    font-size: ${calculateResponsiveSize(14)};
    line-height: 1.25;
  }
  body {
    overflow-y: scroll;
    overscroll-behavior-y: none;
  }
  body.hidden {
    height: 100dvh !important;
  }
  body.hidden .home-wrapper {
    height: 100dvh;
    overflow: hidden;
  }

  /* ----- Fix page transition ----- */
  .page.exiting,
  .page.exited {
    transition: none;
  }

  /* ----- react-select ----- */
  @keyframes selectSlideInOut {
    0% {
      transform: translateY(-1px);
    }
    100% {
      transform: translateY(0);
    }
  }

  /* ----- Animations ----- */
  .fadeIn {
    opacity: 0;
    transition: opacity 1s;
    &.visible {
      opacity: 1;
    }
  }
  .fadeInFromBottom {
    transform: translateY(50px);
    opacity: 0;
    transition: transform 2s, opacity 2s;
    &.visible {
      transform: translateY(0);
      opacity: 1;
    }
  }
`
